/**
 * CheckoutSuccessSocial.js — Social ad conversion landing page.
 * Route: /checkout-success-social
 *
 * Wraps CheckoutSuccess with Meta Purchase pixel event for ad attribution.
 * The event_id matches the server CAPI event for Meta deduplication:
 *   Browser:  fbq('track', 'Purchase', {...}, {eventID: 'purchase_cs_xxx'})
 *   Server:   event_id = 'purchase_cs_xxx' (from Stripe webhook)
 * Meta sees both, deduplicates on event_id, counts one purchase.
 *
 * MAINTENANCE NOTE: If you update CheckoutSuccess.js behavior (password flow,
 * CTAs, copy), it flows through automatically since we render it below.
 */

import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CheckoutSuccess from './CheckoutSuccess';

export default function CheckoutSuccessSocial() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const sessionId = searchParams.get('session_id');

    if (sessionId && window.fbq) {
      // event_id MUST match server CAPI event for Meta deduplication
      const eventId = 'purchase_' + sessionId;

      window.fbq('track', 'Purchase', {
        value: 0,        // Server CAPI event carries the real dollar amount
        currency: 'USD'
      }, {
        eventID: eventId  // Meta's dedup key
      });

      console.log('[Meta Pixel] Purchase event fired with eventID:', eventId);
    }
  }, [searchParams]);

  // Render the standard checkout success flow (password setup, CTAs, etc.)
  return <CheckoutSuccess />;
}